import { useRef } from 'react';

function useInitialRender() {
  const isInitialRender = useRef(true);

  if (isInitialRender.current) {
    isInitialRender.current = false;
    return true;
  }

  return false;
}

export default useInitialRender;